module.exports = __webpack_public_path__ + "static/media/blank.e5bf6c5d.svg";